module.exports = __webpack_public_path__ + "b2b600c3a3afe33e4bb88cc528f6cde3.svg";